import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {CommonService} from '@services/common.service';
import {Favorite} from '@models/favorite';
import {MatDialog} from '@angular/material/dialog';
import {AuthenticationService} from '@services/authentification.service';


@Component({
  selector: 'app-financement',
  templateUrl: './financement.component.html',
  styleUrls: ['./financement.component.scss']
})
export class FinancementComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();
    constructor(
        public cityService: CityService,
        public adService: AdService,
        public commonService: CommonService,
        public authenticationService: AuthenticationService,
        public dialog: MatDialog) {
    }

    edit(event, fields = '') {
        this.favorite = this.adService.cleanInput(this.favorite);

        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }

    ngOnInit() {
        if (this.favorite.apport >= this.favorite.total_price) {
            this.favorite.cash = true;
        }
    }

    toogleCash() {
        if (this.favorite.cash == true) {
            this.favorite.apport = this.favorite.total_price;
            this.favorite.banking_fees = 0;
        } else {
            this.favorite.apport = 0;
        }
        this.edit(null)
    }
}
